import { Injectable } from '@angular/core';

import { HistoryTerm } from './../models/history-term.model';
import { Suggestion } from './../models/suggestion.model';
import { EXPIRES_IN, ITEMS_TO_STORE } from '../constants';

@Injectable({
  providedIn: 'root',
})
export class SearchHistoryUpdater {
  static transformName(name: string): string {
    return name
      .replace(/<[/]?(b)>/gi, '')
      .replace(/\s\s+/g, ' ')
      .trim();
  }

  static normalizeHistory(history: HistoryTerm[]): HistoryTerm[] {
    return [...history]
      .sort((prevTerm: HistoryTerm, nextTerm: HistoryTerm) => nextTerm.expiresAt - prevTerm.expiresAt)
      .slice(0, ITEMS_TO_STORE);
  }

  public saveHistoryTerm(term: HistoryTerm | Suggestion, history?: HistoryTerm[]): HistoryTerm[] {
    const expiresAt = new Date().setDate(new Date().getDate() + EXPIRES_IN);

    const historyMap = new Map();
    history.forEach(historyTerm => historyMap.set(historyTerm.value, historyTerm));

    const nextTermName = SearchHistoryUpdater.transformName(term.value);
    historyMap.set(nextTermName, {
      ...term,
      expiresAt
    });

    const nextHistory = Array.from(historyMap).map(([, historyTerm ]) => historyTerm);
    return SearchHistoryUpdater.normalizeHistory(nextHistory);
  }

  public removeHistoryTerm(term: HistoryTerm | Suggestion, history?: HistoryTerm[]): HistoryTerm[] {
    return history.filter(historyTerm => term.value !== historyTerm.value);
  }
}
